export const HOME = "/";
export const FEED = "/feed";
export const LOGIN = "/login";
export const EVENTS = "/events";
export const ALUMNI = "/alumni";
export const ALUM = "/alumni/:ownerId";
export const COHORT = "/cohort";
export const EMPLOYERS = "/employers";
export const JOBS = "/jobs";
export const JOB = "/jobs/:jobId";
export const ADMIN = "/admin";
export const buildAlumPath = (ownerId) => `/alumni/${ownerId}`;
